import { Col, Form, message, Row } from "antd";
import React from "react";
import s from "../Register/Register.module.scss";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "antd/es/form/Form";
import { resendOTP } from "../../redux/carSlice";

const ResendOTP = () => {
  const dispatch = useDispatch();
  const [form] = useForm();
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  const user = useSelector((state) => state.cars.user)?.email;
  const message = useSelector((state) => state.cars.message);

  const success = () => {
    messageApi.open({
      type: "success",
      content: "Новый ОТП код отправлен на вашу почту!",
    });
  };

  const error = () => {
    messageApi.open({
      type: "error",
      content: "ОТП код неверный!",
    });
  };

  const sendOtp = async (values) => {
    try {
      const res = await dispatch(
        resendOTP({
          email: values.email,
        })
      );
      if (res.type === "user/resendOtp/fulfilled") {
        success();
        navigate("/activateAccount");
      }
      console.log("res", res);
    } catch (err) {
      console.log("err", err);
    }
  };

  return (
    <div className={s.login}>
      {contextHolder}
      <h2 className={s.h2}>
        <img src='/cncars_logo.png' className={s.logo} /> Отправить OTP код еще
        раз
      </h2>
      <Form
        className={s.form}
        layout='vertical'
        form={form}
        onFinish={sendOtp}
        style={{ width: "500px" }}
      >
        <Row>
          <Col span={24}>
            <Form.Item
              name='email'
              label='Введите ваш email'
              rules={[
                {
                  required: true,
                  message: "Введите ваш email",
                },
                { type: "email", message: "Введите корректный email" },
              ]}
            >
              <input placeholder='Введите ваш email' className={s.input} />
            </Form.Item>
          </Col>
        </Row>
        <div className={s.row}>
          <Link to='/resetPassword' className={s.forgetPassword}>
            Запросить код еще раз
          </Link>
        </div>
        <Row>
          <button className={s.enter_btn} type='htmlSubmit'>
            Получить новый OTP код
          </button>
        </Row>
        <div className={s.no_account}>
          Нет аккаунта? &nbsp;
          <Link to='/register' className={s.register_btn}>
            Зарегистрироваться
          </Link>
        </div>
      </Form>
    </div>
  );
};

export default ResendOTP;
